import { path, zipper, isDefined } from "../utils";
import { sma } from "./index";
import { NegativeVolumeIndex as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = { ...defaultOptions };

  function calculator(data = []) {
    const { period, sourcePath, volumePath } = options;

    if (data.length < 2) {
      return [];
    }

    const getPrice = path(sourcePath);
    const getVolumeRaw = path(volumePath);

    // Helper to extract volume from nested structure or direct value
    const getVolume = (d) => {
      const vol = getVolumeRaw(d);
      if (vol && typeof vol === "object" && "volume" in vol) {
        return vol.volume; // Extract from {volume: 9795, direction: "up"}
      }
      return vol;
    };

    // Calculate NVI index
    const nviIndex = [];
    let index = 100; // Start at 100

    for (let i = 0; i < data.length; i++) {
      if (i === 0) {
        nviIndex.push(index);
        continue;
      }

      const currentPrice = getPrice(data[i]);
      const prevPrice = getPrice(data[i - 1]);
      const currentVolume = getVolume(data[i]);
      const prevVolume = getVolume(data[i - 1]);

      // Check for required data
      if (
        currentPrice == null ||
        prevPrice == null ||
        prevPrice === 0 ||
        currentVolume == null ||
        prevVolume == null
      ) {
        nviIndex.push(undefined);
        continue;
      }

      // NVI only changes when volume DECREASES
      if (currentVolume < prevVolume) {
        index *= currentPrice / prevPrice;
      }
      // If volume increased or stayed same, index remains unchanged

      nviIndex.push(index);
    }

    // Calculate moving average of NVI
    const smaCalculator = sma().options({
      windowSize: period,
      sourcePath: "nviValue",
    });

    const nviData = data.map((d, i) => ({ ...d, nviValue: nviIndex[i] }));
    const maResults = smaCalculator(nviData);

    // Combine NVI index and MA into array of objects
    const zip = zipper().combine((nvi, nviMA) => ({
      nvi: isDefined(nvi) ? nvi : undefined,
      nviMA: isDefined(nviMA) ? nviMA : undefined,
    }));

    return zip(nviIndex, maResults);
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return period - 1; // MA requires period bars
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return { ...options };
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
